(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('PolicyAnagController', PolicyAnagController);

    PolicyAnagController.$inject = ['$state', 'PolicyAnag', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PolicyAnagController($state, PolicyAnag, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.currentSearch = pagingParams.search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll () {
            PolicyAnag.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                textFilter: vm.currentSearch ? vm.currentSearch.nameFilter : null
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.policies = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: JSON.stringify(vm.currentSearch)
            });
        }
        
        function onSaveSuccess (result) {
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        vm.toggleActivation = function(policy){
        	policy.isActive = !policy.isActive;
        	var obj = {
        		id: policy.id,
        		activate: policy.isActive
        	}
        	
        	PolicyAnag.activate(obj, onSaveSuccess, onSaveError);
        } ;
    }
})();
